var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaybackRate = function SvgPlaybackRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "100 -940 760 880"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360-840v-80h240v80zm80 440h80v-240h-80zm40 320q-74 0-139.5-28.5T226-186t-77.5-114.5T120-440t28.5-139.5T226-694t114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186t-114.5 77.5T480-80m0-80q116 0 198-82t82-198-82-198-198-82-198 82-82 198 82 198 198 82m0-280"
  })));
};
export default SvgPlaybackRate;